/*global XMLHttpRequest*/
angular.module('mtic').service('EventManager', function ($rootScope, $log, $http, $window, API_CONFIG, API_ROUTES, $cookies, $timeout) {


    if (window.location.href.indexOf('DEBUG_TOUCH') > -1 ){
      window.DEBUG_TOUCH = true;
    }

      $rootScope.eventManagerName = $window.location.hostname;
      /**
       * Broadcast a message from rootScope
       * @param  {String} eventName
       * @param  {Object} eventData
       * @return {angular.$broadcast}
       */
      var broadCast = function(eventName, eventData) {
            return $rootScope.$broadcast(eventName, eventData)
      }
      /**
       * Generates a random string
       * @return {String}
       */
      var genRandomHash = function(){
            return Math.random().toString(36).substr(3,10) + Date.now()
      }
      /**
       * Gets the closets parent instanceName and appends to it the componentType
       * @param  {angular.scope} scope
       * @param  {String} componentType
       * @return {String}
       */
      var computeInstanceName = function(scope, componentType) {
            var instanceName;
            if(scope.$parent) {
                  if(scope.$parent.eventManagerName) {
                        instanceName = scope.$parent.eventManagerName
                  }else{
                        instanceName = computeInstanceName(scope.$parent);
                  }
                  instanceName = instanceName + (componentType ? ( '/' + componentType ) : '');
                  return instanceName;
            }     else  {
                  return componentType;
            }
      }

      /**
       * Checks that the object has a key and its not null
       * @param  {Object}
       * @param  {String}
       * @return {Boolean}
       */
      var hasValue = function(obj, value) {
            return (Object.keys(obj).indexOf(value) > -1) && (obj[value] !== null)
      }
      /**
       * UserInfo
       * this information is generated by the user interacting with our system
       * @type {Object}
       */
      var userInfo = {
            userId: null,//the userId, set at a login event
            sessionId: genRandomHash(),//generated by the user opening the browser
            resource: {
                  id: null,//set when an activity is started
                  slug: null,//set when an activity is started
                  sessionId: null//generated locally when an activity is started
            },
            headers: {}//is set on login
      }
      /**
       * Device Info
       * this information is extracted straight from the user's device
       * @type {Object}
       */
      var deviceInfo = {
            browser: navigator.userAgent,//the browser's userAgent
            platform: navigator.platform,//the operating system
            language: {//the device's language features
                  selected: navigator.language,//their selected language (on their device)
                  options: navigator.languages//the languages that they are able to use
            }
      }
      /**
       * Application Information
       * this information is use to describe the application
       * @type {Object}
       */
      var appInfo = {
            version: 'v7.43.29-rc.110',//the version of the app, this is set from the package.json file (and is extracted a few lines below)
            location: location.href,//the url from which they are using the applicaiton
            host: location.hostname,//the hostname that this app is at
            // language: $cookies.get('bar_language') || 'fr'//the language that they selected IN the application
            language: 'fr'//the language that they selected IN the application
      }
      // ga('set', 'appName', appInfo.location);
      // ga('set', 'appVersion', appInfo.version);
      var allowedEvents = [
            'login:fail',
            'login:first',
            "login:login_as",
            'login:session:clear',
            'browser:tab:beforeunload:warning',
            'browser:tab:beforeunload:cancelled',
            'app:open',
            'language:change',
            //'student:module:open',
            //'teacher:module:open',
            'module:open:resource',
            'mticResource:RESOURCE_LOAD_COMPLETE',
            //'mticResource:RESOURCE_LOAD_FAILED',
            'resource:score:submitted',
            'module:close:resource',
            // 'COMPONENT_LOG',
            'C4_BASELINE_LOG',
            'log:language:options',
            'user:InactiveForThirtyMinutes',
            // 'user:inactiveForOneMinutePing',
            // 'user:idleStart60s',
            // 'user:idleStart300s',
            // 'user:idle_end',
            'language:init',
            'mouse:keyboard:active:first',
            'mouse:keyboard:active',
            'idle:inputs:start',
            'focusout:start',
            'idle:inputs:end',
            'focusout:end',
            'language:change:automatic',
            'language:change:manual',
            'module:change:submodule',
            'module:change:meta',
            'teacher:change:tab',
            'user:view:notification',
            'user:dismiss:notification',
            'user:chat',
            'teacher:download:pdf',
            'teacher:download:instructions',
            'teacher:select',
            'teacher:select:dropdown',
            'set:lesson:options',
            'logout:manual'
      ];
      var reportToOurApi = function(eventName, eventData, instanceName, is_forced){  
        var temp_before_clear = angular.copy(userInfo)
        var timer = 0; 
        if(eventName === 'module:open:resource'){
          timer = 200;
          temp_before_clear = userInfo;
        }else if((eventName === 'mouse:keyboard:active' || eventName === 'idle:inputs:start' || eventName === 'focusout:start' || eventName === 'idle:inputs:end' || eventName === 'focusout:end') && !userInfo.userId){
            return;
        }
        $timeout(function(){
          if((eventName === 'module:open:resource' || eventName === 'module:close:resource') && (!temp_before_clear.resource.slug || !temp_before_clear.resource.id) && (eventData && eventData.slug && eventData.id)){
            userInfo.resource.slug = eventData.slug;
            userInfo.resource.id = eventData.id;
            if(eventName === 'module:open:resource'){
              userInfo.resource.sessionId = genRandomHash();
            }
            temp_before_clear = userInfo;
          }
          var CONFIG = API_CONFIG;
          if(API_CONFIG.MTIC_REPORTING) {
            CONFIG = API_CONFIG.MTIC_REPORTING;
          }
          var api_version = window.location.href.indexOf('pre-live') > -1 || window.location.href.indexOf('mathematic.lu') > -1 || window.location.href.indexOf('mathematic.org') > -1? CONFIG.API_VERSION : CONFIG.API_QC_VERSION;
          var url = CONFIG.REMOTE_API + api_version;
          var headers = {};
  
          if(eventName === 'language:change'){
            eventName = is_forced ? 'language:change:automatic' : 'language:change:manual'
          }else if(eventName ==='open:cycle:prompt'){
            eventName = 'module:open:resource'
          }else if(eventName ==='submit:cycle:prompt'){
            eventName = 'resource:score:submitted'
          }else if(eventName ==='cycle:prompt:close'){
            eventName = 'module:close:resource'
          }
  
          var resource_data = {
            sessionId : temp_before_clear.resource.sessionId,
            slug : temp_before_clear.resource.slug,
            id : temp_before_clear.resource.id
          }
          if (eventData && eventData.resource) {
            if (eventData.resource.sessionId) {
              resource_data.sessionId = eventData.resource.sessionId;
            }
            if (eventData.resource.slug) {
              resource_data.slug = eventData.resource.slug;
            }
            if (eventData.resource.id) {
              resource_data.id = eventData.resource.id;
            }
          }
  
          var payload = {
                'user_id':  temp_before_clear.userId,
                'session_id':  temp_before_clear.sessionId,
                'instance_name':  instanceName,
                'resource_session_id':  resource_data.sessionId,
                'resource_slug':  resource_data.slug,
                'resource_id':  resource_data.id ? Number(resource_data.id) : null,
                'time_stamp_local': moment.utc().format(),
                'event_name':  eventName,
                'event_data':  JSON.stringify(eventData || ''),
                'app_info':  appInfo,
                'device_info':  deviceInfo
          };
          var allowed = true;
          if(allowedEvents.indexOf(eventName) > -1) {
              if ( hasValue(userInfo.headers, 'X-Auth-Session-Key') && hasValue(userInfo.headers, 'X-Auth-Id') ){
                url += API_ROUTES.POST.AUTH_EVENT
                headers = userInfo.headers;
              }else{
                url += API_ROUTES.POST.EVENT;
              }
          }     else {
                allowed = false;
          }
          
          if((eventName === 'browser:tab:beforeunload:warning' || eventName === 'browser:tab:beforeunload:cancelled') && !userInfo.userId){
              allowed = false;
          }
          if(allowed) {
              var headers_modified = angular.copy(headers);
              delete headers_modified.Pragma;
              delete headers_modified['If-Modified-Since'];
              delete headers_modified['Cache-Control'];
              delete headers_modified['X-ACCESS-TOKEN'];
              $http({
                    method: 'POST',
                    url: url,
                    data: payload,
                    headers: headers_modified
              })
              .then(function(){
                    $log.debug('[[EventManager]]', 'Sent to API', eventName, eventData, instanceName)
              })
              .catch(function(e){
                    $log.debug('[[EventManager]]', 'Failed to sent event to vretta db', e, eventName, eventData, instanceName)
              })              
            }
        }, timer)        
      }
      /**
      * EventManager Class
      * This is the main component logger class, all events are routed by this
      * @param {String} componentType best practise is to use the directives name
      * @param {String} instanceName should be computed by the function returned by this service
      * @param {angular.scope} scope  the scope object provided by the link function or $scope
      */
      function EventManager(componentType, instanceName, scope) {
            var listenerDeregisters  = [];
            scope.$on('$destroy', function(){
                  $log.debug('[[EventManager]] DESTROYING', instanceName, listenerDeregisters.length, 'listeners')
                  listenerDeregisters.forEach(function(listenerDeregister){
                        listenerDeregister();
                  })
                  listenerDeregisters  = [];
                  $rootScope.eventManagers['/' + componentType] = null;
            });
            /**
             * Define getters
             */
            Object.defineProperty(this, 'instanceName', {
                  get: function(){
                        return instanceName
                  }
            })
            Object.defineProperty(this, 'componentType', {
                  get: function(){
                        return componentType
                  }
            })
            /**
            * A special syncronous call for when a user is about to refresh or exist the page
            * @return {}
            */
            this.beforeunloadWarning = function(){
                  var eventName = 'browser:tab:beforeunload:warning';
                  if(!userInfo.userId){
                    return;
                  }
                  var request = new XMLHttpRequest();
                  var api_version = window.location.href.indexOf('pre-live') > -1 || window.location.href.indexOf('mathematic.lu') > -1 || window.location.href.indexOf('mathematic.org') > -1 ? API_CONFIG.API_VERSION : API_CONFIG.API_QC_VERSION;
                  var url = API_CONFIG.REMOTE_API + api_version + API_ROUTES.POST.AUTH_EVENT;
                  var payload = {
                        'user_id':  userInfo.userId,
                        'session_id':  userInfo.sessionId,
                        'instance_name':  instanceName,
                        'resource_session_id':  userInfo.resource.sessionId,
                        'resource_slug':  userInfo.resource.slug,
                        'resource_id':  userInfo.resource.id ? Number(userInfo.resource.id) : null,
                        'time_stamp_local': moment.utc().format(),
                        'event_name':  eventName,
                        'event_data':  '',
                        'app_info':  appInfo,
                        'device_info':  deviceInfo
                  };
                  var headers = userInfo.headers;
                  request.open("POST",url,false);
                  request.setRequestHeader("content-type","application/json");
                  request.setRequestHeader("X-Auth-Id",headers['X-Auth-Id']);
                  request.setRequestHeader("X-Auth-Session-Key",headers['X-Auth-Session-Key']);
                  request.setRequestHeader("X-Group-Id",headers['X-Group-Id']);
                  request.send(JSON.stringify(payload));
            }
            /**
            * Broadcast an event from rootScope
            * @param  {String} eventName
            * @param  {Object} eventData
            * @return {angular.broadcast}
            */
            this.broadcast = function(eventName, eventData, is_forced) {
                  var eventLabel = 'General Activity';
                  $log.debug('[[broadcasting]]',{
                        instanceName: instanceName,
                        eventName: eventName,
                        eventData: eventData,
                        userInfo: userInfo,
                        deviceInfo: deviceInfo,
                        appInfo: appInfo
                  })
                  $log.debug('[[broadcasting]]', eventName)
                  // ga('send', 'event', instanceName, eventName, eventLabel, {
                  //       userInfo: userInfo,
                  //       deviceInfo: deviceInfo,
                  //       appInfo: appInfo,
                  //       // eventData: eventData
                  // });
                  reportToOurApi(eventName, eventData, instanceName, is_forced);
                  broadCast(eventName,eventData);
            }
            /**
            * A special broadcast for items (this will be wrapped around the iframe lesson)
            * @param  {String} itemComponentId
            * @param  {String} eventName
            * @param  {Object} eventData
            * @return {null}
            */
            this.itemBroadcast = function(itemComponentId, eventName, eventData){
                  var eventLabel = 'General Activity';
                  $log.debug('[[item -> broadcasting]]',{
                        componentId: itemComponentId,
                        instanceName: instanceName,
                        eventName: eventName,
                        eventData: eventData,
                        userInfo: userInfo,
                        deviceInfo: deviceInfo,
                        appInfo: appInfo
                  })
                  // ga('send', 'event', instanceName, eventName, eventLabel, {
                  //       userInfo: userInfo,
                  //       deviceInfo: deviceInfo,
                  //       appInfo: appInfo,
                  //       // eventData: eventData
                  // });
                  reportToOurApi(eventName, eventData, instanceName + '/' + itemComponentId)
            }
            /**
            * Listen to events on LOCAL scope
            * @param  {String}   eventName
            * @param  {Function<Event,Object>} cb
            * @return {angular.$on}
            */
            this.listen = function(eventName, cb) {
                  $log.debug('[[EventManager]]',instanceName ,'is listening to', eventName)
                  var listenerDeregister = scope.$on(eventName, cb);
                  listenerDeregisters.push(listenerDeregister)
                  return listenerDeregister;
            }
            this.getlistenerDeregisters = function(){
                  return listenerDeregisters;
            }
            this.flush = function(){
                  $log.debug('[[EventManager]] Flushing', listenerDeregisters)
                  listenerDeregisters.forEach(function(listenerDeregister){
                        listenerDeregister();
                  })
                  listenerDeregisters  = [];
            }
            /**
            * Sets the current userId
            * @param  {String} userId
            * @return {}
            */
            this.setUserInfo = function(userId){
                  userInfo.userId = Number(userId);
                  // ga('set', 'userId', String(userId));
            }
            /**
            * Sets the activity
            * @param  {String} activitySlug
            * @return {}
            */
            this.setResourceSession = function(resourceSlug, resourceId) {
              userInfo.resource.slug = resourceSlug;
              userInfo.resource.id = resourceId;
              userInfo.resource.sessionId = genRandomHash();
            }
            /**
            * Gets the sessionId
            */
            this.getResourceSession = function() {
                  return userInfo.resource.sessionId
            }
            /**
            * Resets the resource session
            * @return {}
            */
            this.resetResourceSession = function(){
                  userInfo.resource.sessionId = genRandomHash();
            }

            /**
            * Gets the session/resource info
            */
            this.getResourceInfo = function() {
              return {
                slug : userInfo.resource.slug,
                id : userInfo.resource.id,
                sessionId : userInfo.resource.sessionId
              }
            }
            /**
            * Clears the activity session
            * @return {}
            */
            this.clearResourceSession = function(){
                  userInfo.resource.slug = null;
                  userInfo.resource.id = null;
                  userInfo.resource.sessionId = null;
            }
            /**
            * Clears the loginSession
            * @return {null}
            */
            this.clearLoginSession = function(){
                  this.clearResourceSession()
                  userInfo.userId = null;
                  userInfo.groupId = null;
                  userInfo.headers = {};
            }
            /**
            * Sets the login headers
            * @param {String}
            */
            this.setHeaders = function(headers) {
                  userInfo.headers = headers;
            }
            /**
            * Sets the current language and emit a language change event
            * @param  {String} slug
            * @return {}
            */
            this.setLanguage = function(slug, is_forced){
                  appInfo.language = slug;
                  //var event_name = is_forced ? 'language:change:automatic' : 'language:change:manual'
                  this.broadcast('language:change', slug, is_forced)
                  if(!is_forced){
                        this.broadcast('set:user:language', slug)
                  }
            }
            this.getLanguage = function(){
                return appInfo.language;
            }
      }
      /**
       * Event Manager make function
       * This is done in order to get the current instanceName
       * and assign the class to the base scope
       * @param {String} componentType best practise is to use the directives name
       * @param {angular.scope} scope  the scope object provided by the link function or $scope
       */
      var service = function(componentType, scope) {
            var instanceName = '/' + componentType;
            var eventManager;
            if(!scope) {//this should ONLY happen in the case of SERVICES or FACTORIES
                  if(!$rootScope.eventManagers){
                    $rootScope.eventManagers = {};
                  }
                  eventManager = new EventManager(componentType, instanceName, $rootScope)
                  $rootScope.eventManagers[instanceName] = eventManager;
            }     else  {// this happens for directives and controllers
                  instanceName = computeInstanceName(scope, componentType)
                  eventManager = new EventManager(componentType, instanceName, scope)
                  scope.eventManagerName = instanceName;
                  $log.debug('[[EventManager]] Initilized', instanceName)
                  //TODO remove circular reference between scope & event
                  // scope.eventManager = eventManager
            }
            return eventManager;
      }
      service.disableBeforeUnloadMsg = false;
      return service;
})
